



























































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import Modal from '@/components/poultry/Modal.vue';
import { dropdownStores } from '@/store/poultry/dropdowns';
import { farmStores } from '@/store/poultry/farm';
import { constructValidationError } from '@/utils/errors';
import { Farm } from '@/models/poultry/farm.model';
import { Country, Region, State, City } from '@/models/poultry/country.model';
import { ToastProgrammatic as Toast } from 'buefy';
import { axios } from '@/utils/axios';
import { Endpoints } from '@/store/poultry/endpoints';

@Component({
  components: {
    Modal,
  },
})
export default class CreateFarmForm extends Vue {
  store = farmStores.create;
  countryStore = dropdownStores.country;
  errors: { [key: string]: string } = {};
  farm: Farm = {
    name: '',
    addressLine1: '',
    addressLine2: '',
    postcode: '',
    cityId: '',
    stateId: '',
    regionId: '',
    countryId: '',
  };

  countries: Country[] = [];
  states: State[] = [];
  cities: City[] = [];
  regions: Region[] = [];

  @Watch('error')
  get validationErrors() {
    const error = constructValidationError(this.store.error);
    return error;
  }

  async created() {
    this.fetchCountriesDropdown();
  }

  async fetchCountriesDropdown() {
    try {
      const { data } = await axios.get<Country[]>(Endpoints.Countries);
      this.countries = data;
    } catch (error) {
      console.error(error);
    }
  }

  async fetchRegionsDropdown() {
    try {
      const params: {[key: string] : string} = {};

      if (this.farm.countryId) {
        params['country'] = this.farm.countryId;
      }

      const { data } = await axios.get(Endpoints.Regions, 
        {params},
      );

      this.regions = data;
    } catch (error) {
      console.error(error);
    }
  }

  async fetchStatesDropdown() {
    try {
      const params: {[key: string] : string} = {};

      if (this.farm.regionId) {
        params['region'] = this.farm.regionId;
      }

      const { data } = await axios.get(Endpoints.States, 
        {params},
      );

      this.states = data;
    } catch (error) {
      console.error(error);
    }
  }

  async fetchCitiesDropdown() {
    try {
      const params = {} as { [key: string]: string };

      if (this.farm.stateId) {
        params['state'] = this.farm.stateId;
      }

      const { data } = await axios.get(Endpoints.Cities, {
        params,
      });

      this.cities = data;
    } catch (error) {
      console.error(error);
    }
  }

  async handleFormSubmitted() {
    try {
      if (this.farm.name && this.farm.countryId && this.farm.cityId && this.farm.stateId) {
        this.store.updateState(this.farm);
        await this.store.create();

        if (this.store.isCreated) {
          Toast.open({
            type: 'is-success',
            message: 'Farm successfully created',
          });
          this.closeCreateFarmModal();
          await farmStores.list.fetchAll();
        }
      } else {
        Toast.open({
          type: 'is-danger',
          message: 'Required fields cannot be empty',
        });
      }
    } catch (error) {
      Toast.open({
        type: 'is-danger',
        message: 'Farm cannot be created',
      });
    }
  }

  handleLocationChanged(type: string) {
    if (type === 'city') {
      return;
    } else if (type === 'country') {
      if (!this.farm.countryId && this.farm) {
        this.farm.regionId = '';
        this.farm.stateId = '';
        this.farm.cityId = '';
        this.regions = [];
        this.states = [];
        this.cities = [];
      } else {
        this.fetchRegionsDropdown();
      }
    } else if (type === 'region' && this.farm) {
      if (!this.farm.regionId) {
        this.farm.stateId = '';
        this.farm.cityId = '';
        this.states = [];
        this.cities = [];
      } else {
        this.fetchStatesDropdown();
      }
    } else if (type === 'state') {
      if (!this.farm.stateId) {
        this.farm.cityId = '';
        this.cities = [];
      } else {
        this.fetchCitiesDropdown();
      }
    }
    this.countryStore.fetchCityByStateCode();
  }

  @Emit('onClose')
  closeCreateFarmModal() {}
}
